export function deviceHasTouchEnabled(): boolean {
	return (
		'ontouchstart' in window ||
		navigator.maxTouchPoints > 0 ||
		(navigator as any).msMaxTouchPoints > 0
	);
}

export function isAppleDevice(): boolean {
	const platform: string =
		(navigator as any).userAgentData &&
		(navigator as any).userAgentData.platform
			? (navigator as any).userAgentData.platform
			: navigator.platform;
	return /(Mac|iPhone|iPod|iPad)/i.test(platform);
}

export function setLocalStorageAndTriggerEvent(
	key: string,
	value: string
): void {
	const oldValue: string | null = localStorage.getItem(key);
	localStorage.setItem(key, value);
	const event: StorageEvent = new StorageEvent('storage', {
		key,
		newValue: value,
		oldValue,
		storageArea: localStorage,
		url: window.location.href
	});
	window.dispatchEvent(event);
}
